module.exports = __webpack_public_path__ + "img/triangle_background.c7de518c.png";